import template from "./analytics-detail.html";
import controller from "./analytics-detail.controller";
import "./analytics-detail.scss";

const AnalyticsDetailComponent = {
    template,
    controller,
    controllerAs: "details"
};

export default AnalyticsDetailComponent;


// WEBPACK FOOTER //
// ./sources/components/analytics/analytics-detail/analytics-detail.component.js